import { useWSQuery, WSQueryConfig } from "@ws-react-query";
import { WSServiceError } from "../../../utils/serviceHelper";
import { getInsuranceCoverage } from "../../../services/api/insurance/coverage/getInsuranceCoverage";
import { IInsuranceCoverage } from "../../../services/api/insurance/coverage/types";

export const QUERY_INSURANCE_COVERAGE = "QUERY_INSURANCE_COVERAGE";

export const useInsuranceCoverage = (
  insuranceCoverageId: string,
  config?: WSQueryConfig<IInsuranceCoverage, WSServiceError>
) =>
  useWSQuery(
    [QUERY_INSURANCE_COVERAGE, insuranceCoverageId],
    () => getInsuranceCoverage(insuranceCoverageId),
    config
  );
